import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { makeRequest } from "../../utils/request";

export type FileState = {
  isLoading: boolean;
  error: string | null;
};

const initialState: FileState = {
  isLoading: false,
  error: null,
};

const uploadFile = createAsyncThunk("file/uploadFile", async (payload: { type: string; file: File }) => {
  const response = await makeRequest<{ data: string }>(`/v1/files/${payload.type}`, {
    method: "POST",
    file: payload.file,
  });

  return response.data;
});

const fileSlice = createSlice({
  name: "file",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(uploadFile.fulfilled, (state, action) => {
      state.isLoading = false;
    });

    builder.addCase(uploadFile.rejected, (state) => {
      state.isLoading = false;
      state.error = "Failed to upload file";
    });

    builder.addMatcher(
      (action) => action.type.startsWith("file/") && action.type.endsWith("/pending"),
      (state) => {
        state.isLoading = true;
        state.error = null;
      },
    );
  },
});

export const fileReducer = fileSlice.reducer;

export const fileActions = {
  ...fileSlice.actions,
  uploadFile,
};
